// middleware/localStorage.js

export const localStorageMiddleware = store => next => action => {
    const result = next(action);
    // Save the Redux store state to localStorage after each action
    localStorage.setItem('StudentAttendance', JSON.stringify(store.getState()));
    return result;
  };
  